exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-container {\n  display: flex;\n  height: 216px;\n}\n\n.profile-legends {\n  display: flex;\n  padding: 20px 50px;\n  min-height: 100px;\n  align-items: center;\n  flex-wrap: wrap;\n  overflow-y: auto;\n}\n\n.legend-item {\n  display: flex;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin: 5px 15px 5px 0;\n}\n\n.legend-item__color {\n  min-width: 12px;\n  min-height: 12px;\n  max-width: 12px;\n  max-height: 12px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.legend-item__label {\n  font-size: 12px;\n  min-width: 150px;\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.legend-item--deactivated {\n  opacity: 0.5;\n}\n\n.legend-item:hover {\n  font-weight: bold;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/profile/analysis/legends.scss
// module id = 2454
// module chunks = 0